/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link supplier_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/cons-intro",
  DASHBOARD: "/cons-dashboard",
  INBOX: "/cons-inbox",
  OUTBOX: "/cons-outbox",

  //HB
  CUSTOMER_V4_HB_HOME_PAGE: "/hb-home-page",
  CUSTOMER_V4_HB_LOGIN: "/hb-login",

  //Employee
  CUSTOMER_V4_HB_EMPLOYEE: "/hb-employee",

  CONSTRUCTION_ESTIMATE_LIST: "/cons-estimate-list",

  CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN: "/material-price-breakdown",
  CONSTRUCTION_MATERIAL_PRICE_BREAKDOWN_DETAILS:
    "/material-price-breakdown-detail",

  CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN: "/customer-sales-breakdown",
  CONSTRUCTION_CUSTOMER_SALES_BREAKDOWN_DETAILS:
    "/customer-salesbreakdown-details",

  CONSTRUCTION_QUOTATION_ESTIMATE: "/quotation-estimate",
  CONSTRUCTION_QUOTATION_ESTIMATE_DETAILS: "/quotation-estimate-details",

  CONSTRUCTION_FINANCE_PRICE_BREAKDOWN_CREATION:
    "/finance-price-breakdown-creation",

  CONSTRUCTION_CUSTOMER_ESTIMATE_E1: "/customer-estimate-specification",
  CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION: "/customer-estimate-creation",
  CONSTRUCTION_CUSTOMER_ESTIMATE_MATERIAL_DETAILS:
    "/customer-estimate-material-details",

  CONSTRUCTION_QUOTATION_LIST: "/cons-quotation-list",
  CONSTRUCTION_ENTRY_LIST: "/cons-entry-list",

  CONSTRUCTION_JOB_LIST: "/cons-job-list",

  CONSTRUCTION_ESTIMATE_SPECIFICATION_LIST: "/corns-estimation-list",
  CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS:
    "/cons-estimation-details",
  CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION:
    "/cons-estimation-revision",

  CONSTRUCTION_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW:
    "/customer-estimate-specification-workflow",
  CONSTRUCTION_CUSTOMER_ESTIMATE_CREATION__WORKFLOW:
    "/customer-estimate-creation-workflow",

  //REPORTS
  CONSTRUCTION_REPORTS: "/cons-reports",
  CONSTRUCTION_REPORT_DETAILS: "/construction-report-details",
  CONSTRUCTION_MATERIAL_LIST: "/cons-material-List",
  CONSTRUCTION_CUST_LIST:"/cons-customer-list",
  CONSTRUCTION_CUST_DETAILS:"/cons-customer-details",

  CONSTRUCTION_INQ_LIST:"/cons-customer-inquiry",
  CONSTRUCTION_INQ_DETAILS:"/cons-inquiry-details",
  CONSTRUCTION_QNT_LIST:"/cons-customer-quotation",
  CONSTRUCTION_QNT_DETAILS:"/cons-qtn-details"

});
